import { createLazyFileRoute } from "@tanstack/react-router";

import { EditUserPage } from "@/features/admin/routes/UserEdit";

export const Route = createLazyFileRoute("/_auth/admin/users/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditUserPage {...params} />;
  },
});
